module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<table>\n<%\nif(resourceData.copyright){\n%>\n<tr>\n<td class=\"title\">Copyright:</td>\n<td class=\"content\"><%= resourceData.copyright %></td>\n</tr>\n<%\n}\n%>\n<tr>\n<td class=\"title\">Zeitraum:</td>\n<td class=\"content\"><%= resourceData.month || 0 %>.<%= resourceData.year || 0 %></td>\n</tr>\n</table>\n<div class=\"right\">\n<%= resourceData.counter || 0 %>\n</div>\n</div>"
  , __filename = "components/templates/mediaManagement/artImageArchive/baseFormMediaImageAdditionalData.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<table>\n")
    ; __line = 3
    ; 
if(resourceData.copyright){

    ; __line = 5
    ; __append("\n<tr>\n<td class=\"title\">Copyright:</td>\n<td class=\"content\">")
    ; __line = 8
    ; __append(escapeFn( resourceData.copyright ))
    ; __append("</td>\n</tr>\n")
    ; __line = 10
    ; 
}

    ; __line = 12
    ; __append("\n<tr>\n<td class=\"title\">Zeitraum:</td>\n<td class=\"content\">")
    ; __line = 15
    ; __append(escapeFn( resourceData.month || 0 ))
    ; __append(".")
    ; __append(escapeFn( resourceData.year || 0 ))
    ; __append("</td>\n</tr>\n</table>\n<div class=\"right\">\n")
    ; __line = 19
    ; __append(escapeFn( resourceData.counter || 0 ))
    ; __append("\n</div>\n</div>")
    ; __line = 21
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/mediaManagement/artImageArchive/baseFormMediaImageAdditionalData.ejs

}